import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .ant-btn {
    border-radius: 40px;
    padding: 0 40px;
    height: 40px;
    span {
      font-size: 16px;
      color: ${theme.white};
    }

    &.ant-btn-lg {
      width: 260px;
      height: 50px;
    }

    &.dynamic {
      min-width: 250px;
      max-width: 100%;
      min-height: 66px;
      width: auto;
      height: auto;
      white-space: pre-wrap;
      word-break: break-word;
    }

    &.primary {
      background-color: ${theme.primaryRed};
      border: 0;
      &:hover {
        background-color: ${theme.darkRed};
      }
      &[disabled] {
        background-color: ${theme.disableButton};
        box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
      }
    }

    &.ghost {
      border: 2px solid ${theme.primaryRed};
      background-color: transparent;
      span {
        color: ${theme.primaryRed};
      }
      &:hover {
        background-color: ${theme.primaryRed};
        span {
          color: ${theme.white};
        }
      }
      &[disabled] {
        border: 0;
        background-color: ${theme.disableButton};
        box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
        span {
          color: ${theme.white};
        }
      }
    }

    &.ant-btn-sm {
      height: 32px;
      padding: 0 20px;
      span {
        font-size: 14px;
      }
    }
  }

  .btn-cta {
    width: 254px;
    height: 66px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: ${breakpoint.md}) {
    .ant-btn {
      &.dynamic {
        min-width: 165px;
        min-height: 45px;
        padding: 5px 40px;
      }
    }
  }

  @media (max-width: ${breakpoint.sm}) {
    .btn-cta {
      width: 165px;
      height: 45px;
      padding: 5px 5px;
      box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
    }
  }
`
